/**
 * Web component that displays a modal dialog asking the user to confirm an action.
 * 
 * @example
 * const confirmationModal = document.querySelector(
      '[data-quick-order-delete-confirm]'
    );
    const shouldRemove = await confirmationModal.showDialogAndResolvePromise({
      message: `This will remove everything. Are you sure?`
    });

    if (shouldRemove) {
      // do something
    }

    Note, the liquid snippet confirmation-modal.liquid renders the custom element and loads this js
 */

class ConfirmationModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.defineDefaultTranslations();
    this.render();
  }

  defineDefaultTranslations() {
    const { titleText, confirmText, cancelText } =
      globalThis.PxlApp.translations.confirmationModal;
    this.defaultTitleText = titleText;
    this.defaultConfirmText = confirmText;
    this.defaultCancelText = cancelText;
  }

  showDialogAndResolvePromise(config) {
    this.render(config);
    const dialog = this.querySelector('dialog');
    dialog.showModal();
    const confirmButton = this.querySelector('[data-confirm-button]');
    const cancelButton = this.querySelector('[data-cancel-button]');

    return new Promise(resolve => {
      confirmButton.addEventListener('click', () => {
        resolve(true);
        dialog.close();
      });

      // if the user presses escape to close the modal, same as cancel
      cancelButton.addEventListener('cancel', () => {
        resolve(false);
        dialog.close();
      });

      cancelButton.addEventListener('click', () => {
        resolve(false);
        dialog.close();
      });
    });
  }

  render({
    title = this.defaultTitleText,
    message = '',
    confirmButtonText = this.defaultConfirmText,
    cancelButtonText = this.defaultCancelText
  } = {}) {
    this.innerHTML = `
      <dialog>
        <h2 class="heading-s title">${title}</h2>
        <p class="body-1">${message}</p>
        <div class="button-group">
          <button class="btn-primary" data-confirm-button>${confirmButtonText}</button>
          <button class="btn-secondary" data-cancel-button>${cancelButtonText}</button>
        </div>
      </dialog>
    `;
  }
}

customElements.define('confirmation-modal', ConfirmationModal);
